import { Loader } from '@neo.tax/shared';

import { useAscHomeRedirect } from './hooks';
import { AscHomeLayout } from './organisms';

export const AscHome = (): React.ReactElement => (
  <Loader useRedirect={useAscHomeRedirect}>
    <AscHomeLayout />
  </Loader>
);
